import _defineProperty from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
var __jsx = React.createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from "react";
import { t } from "i18next";
import DateRangeInput from "../FormComponents/DateRangeInput";
import Tag from "../SearchFilters/Tag";
import Toast from "../Toast";
var Filters = function Filters(_ref) {
  var filters = _ref.filters,
    setFilters = _ref.setFilters;
  var handleDateRangeChange = function handleDateRangeChange(value) {
    if (value[0] > new Date() || value[1] > new Date()) {
      Toast.error("Invalid Date! Future dates cannot be selected");
      return;
    }
    setFilters(_objectSpread(_objectSpread({}, filters), {}, {
      dateRange: value
    }));
  };
  var setDate = function setDate(daysFrom, daysTo) {
    var d = new Date();
    var e = new Date();
    d.setDate(d.getDate() + daysFrom);
    e.setDate(e.getDate() + daysTo);
    setFilters(_objectSpread(_objectSpread({}, filters), {}, {
      dateRange: [d, e]
    }));
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "space-y-6"
  }, /*#__PURE__*/React.createElement("div", {
    className: "space-y-3"
  }, /*#__PURE__*/React.createElement("div", {
    className: "text-[12px] font-semibold"
  }, t("date_key")), /*#__PURE__*/React.createElement(DateRangeInput, {
    tooltip: t("scan_upload_date"),
    placeholder: t("date_filter_placeholder"),
    value: filters.dateRange,
    onChange: handleDateRangeChange
  }), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-wrap gap-3"
  }, /*#__PURE__*/React.createElement(Tag, {
    label: t("export_data_modal.last_1_week"),
    onClick: function onClick() {
      return setDate(-7, 0);
    }
  }), /*#__PURE__*/React.createElement(Tag, {
    label: t("export_data_modal.last_1_month"),
    onClick: function onClick() {
      return setDate(-30, 0);
    }
  }))));
};
export default Filters;